module.exports = __webpack_public_path__ + "img/point4.8fcdaa9b.jpg";